<script>
    import AppIcon from "./AppIcon.svelte";

    export let size = "normal";
    export let strokeWidth = 1;
    export let expanded = false;
</script>

<span class="d-block caret-icon" class:expanded={expanded}>
    <AppIcon icon="chevron-left" {size} {strokeWidth}/>
</span>

<style>
    .caret-icon {
        transition: .3s all ease;
    }

    .caret-icon.expanded {
        transform: rotate(-90deg);
    }
</style>